
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import { ILoginModel, ILoginPartnerModel } from '@/models/login.model';

  import accountService from '@/services/account.service';

  @Component({
    computed: {
      ...mapGetters([
        'redirectUrl',
        'clientId'
      ])
    }
  })
  export default class LoginPartner extends Vue {
    @Prop({ type: Object as () => ILoginModel })
    public user!: ILoginModel;

    data() {
      return {
        loginPartnerUrl: ''
      }
    };

    created() {
      this.$store.dispatch("updateIsLoading", true);

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL +
        "partner/login-url?redirectUrl=" + this.$store.getters.redirectUrl +
        "&clientId=" + this.$store.getters.clientId;

      const form = { Id_User: this.user.Id_User, AuthPartner: this.user.AuthPartner, Username: this.user.Username, Email: this.user.Email } as ILoginPartnerModel;
      accountService.post<ILoginPartnerModel, string>(this, url, form)
        .then(response => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.loginPartnerUrl = response;
        });
    }

    public goToLoginView() {
      this.$emit('update:view', 'LoginHome');
    }
  }
